export const ROUTER = {
    HOME:'/',
    AUTHENTICATION:'/authentication',
    ENTER:'/enter',
    ROOM:'/room',
    RESERVE_ROOM_DATE:'/reserve-room/date',
    RESERVE_ROOM_TIME:'/reserve-room/time',
    RESERVE_CONFIRM:'/reserve-room/confirm',
    SETTING:'/setting',
    SYSTEMS:'/systems',
    PAYMENT:'/payment',
    SETTING_ROOM:'/setting-room',
    BOOKING_TRACKING:'booking-tracking'
}